/** IMS 轉倉列表固定只查一般轉倉（MANUAL）；不寫入 URL。 */
export const STOCK_TRANSFER_LIST_SOURCE_TYPE = 'MANUAL';

export function applyStockTransferListSourceTypeFilter(filters = {}) {
  const { sourceType: _ignored, ...rest } = filters;
  return {
    ...rest,
    sourceType: STOCK_TRANSFER_LIST_SOURCE_TYPE,
  };
}

export function stripStockTransferListSourceTypeFromFilters(filters = {}) {
  const { sourceType: _ignored, ...rest } = filters;
  return rest;
}

export function withStockTransferListSourceType(listQuery) {
  return {
    ...listQuery,
    filters: applyStockTransferListSourceTypeFilter(listQuery?.filters),
  };
}

export function stripStockTransferListSourceTypeFromListQuery(listQuery) {
  return {
    ...listQuery,
    filters: stripStockTransferListSourceTypeFromFilters(listQuery?.filters),
  };
}
